import type { IGenericBaseModel } from "models/shared/GenericBaseModel";
import { ContainerModel } from "models/locker/entities/ContainerModel";

export interface IModuleModel extends IGenericBaseModel {
  uuid: string;
  height: number
  width: number
  ordering: number
  containers: ContainerModel[]
}

export class ModuleModel implements IModuleModel {
  uuid: string;
  key: React.Key;
  height: number
  width: number
  ordering: number
  containers: ContainerModel[]

  constructor(data: IModuleModel) {
    this.uuid = data.uuid;
    this.key = data.uuid;
    this.height = data.height;
    this.width = data.width;
    this.ordering = data.ordering;
    this.containers = data.containers.map(i => new ContainerModel(i));
  }
}